import { styled } from 'dripsy';
import React from 'react';
import { View, ViewProps } from 'react-native';

import { ColorType } from '@types';

const StyledView = styled(View)((props: ILineProps) => ({
  backgroundColor: props.color ?? '$background30',
  height: 1,
  width: '100%',
}));

export interface ILineProps extends ViewProps {
  color?: ColorType;
}

export function Line(props: ILineProps) {
  return <StyledView {...props} />;
}
